module.exports = __webpack_public_path__ + "static/media/IMG_6333.a5eaac20.JPG";